import { reqGetCurrentUser } from "../request/ucenterapi/uc/internal/common/getCurrentUser/get.js";
import { ref } from "vue-demi";
const currentUser = ref(null);
function getCurrentUser() {
  if (!currentUser.value) {
    reqGetCurrentUser().then((user) => currentUser.value = user);
  }
  return currentUser;
}
export { getCurrentUser };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/currentUser.js